import { render, staticRenderFns } from "./spirits.vue?vue&type=template&id=1a987d14"
import script from "./spirits.vue?vue&type=script&lang=js"
export * from "./spirits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports